<template>
	<AppDialog :dialogName="dialogName" :width="900" :max-width="500">
		<div class="p-4">
			<div class="dialog-title">{{ title }}</div>
			<div class="dialog-description">All test values not entered here will be taken from the step setup.</div>
			<div class="dialog-body pb-4">
				<ParamDispatcher
					v-for="param in replaceParams"
					:node="node"
					:nodeService="service"
					:nodeAction="action"
					:param="param"
					:key="param.key"
					hasEditPermissions
					@update-input-field="updateInputField"
				/>
			</div>
			<div class="flex-centerize">
				<PrimaryButton class="dialog-bottom" :disabled="!isBtnEnabled || loading" :loading="loading" @click="test">{{
					testBtnText
				}}</PrimaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from './AppDialog/AppDialog';
import ParamDispatcher from '@/components/BlockEditor/BlockEditorParams/ParamDispatcher.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { testStep } from '@/store/modules/selectedNode/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import ErrorHandlingService from '@/utils/error-handling-service';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';

const removeEmptyObjectsByKeys = (object) => {
	const newObject = {};
	Object.keys(object).forEach((key) => {
		if (!isNullOrUndefinedOrEmpty(object[key])) {
			newObject[key] = object[key];
		}
	});
	return object;
};

export default {
	name: 'TestWithReplaceParamsDialog',
	components: {
		AppDialog,
		ParamDispatcher,
	},
	props: {
		title: { type: String },
		testBtnText: { type: String },
		replaceParams: { type: Array },
		service: { type: Object },
		action: { type: Object },
		node: { type: Object },
		dialogName: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		isBtnEnabled() {
			return this.replaceParams.every((param) => (param.required ? !isNullOrUndefinedOrEmpty(this.cleanReplacedParams[param.key]) : true));
		},
		cleanReplacedParams() {
			return removeEmptyObjectsByKeys(this.replacedParamsMap);
		},
	},
	methods: {
		...mapActionsShorthand({
			testStep,
		}),
		updateInputField({ map: { key, value } = {} }) {
			this.$set(this.replacedParamsMap, key, value);
		},
		async test() {
			try {
				this.loading = true;
				await this.testStep({
					test_replace_params_map: this.cleanReplacedParams,
				});
				this.loading = false;
				AppDialogManagerService.closeCurrentDialog();
			} catch (e) {
				this.loading = false;
				this.$toast.error(ErrorHandlingService.extractErrorMessage(e));
			}
		},
	},
	data() {
		return {
			replacedParamsMap: {},
			loading: false,
		};
	},
	mounted() {
		this.replaceParams.forEach((param) => {
			this.$set(this.replacedParamsMap, param.key, this.node?.params_map?.[param.key]);
		});
	},
};
</script>

<style scoped lang="scss"></style>
